import { Injectable } from '@angular/core';

import { Observable, of, catchError, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import {
  GetBrNavigationsResponse,
  NavigationResponse,
} from './appstate.models';
import { AppStatePartialState, APPSTATE_FEATURE_KEY } from './appstate.reducer';
import { AppstateService } from './appstate.service';
import { AppstateFacade } from './appstate.facade';
import { take } from 'rxjs/operators';

@Injectable()
export class NavResolver {
  isInternalUser: string;
  isFromBRPortal: string;
  navigation$ = this.appstateFacade.navigation$;

  constructor(
    private cookieService: CookieService,
    private apiService: AppstateService,
    private store$: Store<AppStatePartialState>,
    private appstateFacade: AppstateFacade,
  ) {}

  resolve(): Observable<any> {
    this.isInternalUser = this.cookieService.get('is-crp-internal');
    this.isFromBRPortal = this.cookieService.get('is-broker');

    if (!(!this.isInternalUser || this.isInternalUser === 'false')) {
      return of();
    }

    let storeNavigation: NavigationResponse | undefined;

    this.store$.pipe(take(1)).subscribe((store) => {
      storeNavigation = store[APPSTATE_FEATURE_KEY].navigation;
    });

    if (!storeNavigation) {
      localStorage.removeItem('group-id');
      localStorage.removeItem('client-id');
      localStorage.removeItem('source-cd');

      return this.navigation$;

      // Old Code
      /*  return this.apiService.getBrokerNavigations().pipe(
        catchError((error) => {
          this.appstateFacade.sendAnalytics({
            event: 'error',
            reqData: {
              requirementId: 'acCFBGlobER001',
              userStory: 'MTD-3109',
              hitType: 'error',
            },
            errorData: {
              errorType: 'Navigation_API',
              errorCause:
                'Our application is currently unavailable. Please try again later.',
              errorCode: 'E99999',
            },
            v2: 'CFB - Home Dashboard',
          });
          return throwError(error);
        }),
      ); */
    }

    return of();
  }
}
